export default __webpack_public_path__ + "static/media/Download-icon.5b10b3bf.svg";